export default __webpack_public_path__ + "static/media/books-08.485d1e41.jpg";